import { FAIcon, type IconTheme } from '@nextgen-web-framework/all';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import styles from './ProductFlag.module.scss';

type ProductFlagProps = {
  iconName: IconName;
  theme?: IconTheme;
  text?: string;
};

export const ProductFlag = ({ iconName, theme, text }: ProductFlagProps) => (
  <div data-testid="product-flag-testid" className={styles['produtc-flag-container']}>
    <FAIcon iconName={iconName} theme={theme} />
    {text}
  </div>
);
